import React from 'react';
import { styled } from "styled-components";

const Cont = styled.div`
  display: flex;
  border-radius: 15px;
  padding: 20px;
  margin: 10px;
  width: 100%;
  top: 22px;
  background-color: #FFFFFF;
  fill: var(--White-FF, #FFF);
  filter: drop-shadow(0px 13.551px 18.068px rgba(50, 32, 64, 0.05)) drop-shadow(0px 36.137px 36.137px rgba(29, 0, 91, 0.10)) drop-shadow(0px -1.807px 3.614px rgba(36, 0, 81, 0.00)) drop-shadow(3px 0px 8px rgba(0, 11, 50, 0.08))
`;

const Block = ({ children, className, style }) => {
  return (
    <Cont className={className} style={style}>
      {children}
    </Cont>
  );
}

export default Block;
